import React from 'react';
import { Checkbox } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import './aiCrew.css';

/**
 * CandidateRow - Renders an individual candidate row with checkbox, name, trade,
 * and API-provided plus/caution chips, grouped as green ticks and red crosses.
 */
export default function CandidateRow({
  candidate,
  selected = false,
  onToggle,
}) {
  if (!candidate) return null;

  const chips = candidate.chips || [];
  const tradeInfo = [candidate.trade, candidate.union].filter(Boolean).join(' · ') || 'Worker';

  return (
    <div
      className={`ai-crew-candidate-row ${selected ? 'selected' : ''}`}
      data-testid={`candidate-row-${candidate.employeeId}`}
    >
      <Checkbox
        checked={selected}
        onChange={() => onToggle && onToggle(candidate.employeeId)}
      />

      <div className="ai-crew-candidate-info">
        <span className="ai-crew-candidate-name">{candidate.name}</span>
        <span className="ai-crew-candidate-trade">{tradeInfo}</span>
      </div>

      <div className="ai-crew-candidate-chips">
        {[['plus', 'Positives'], ['caution', 'To watch']].map(([kind, title]) => {
          const group = chips.filter((chip) => (chip.kind === 'caution') === (kind === 'caution'));
          if (!group.length) return null;
          return (
            <div key={kind} className="ai-crew-chip-group" aria-label={title}>
              {group.map((chip, idx) => (
                <span
                  key={`${chip.code || idx}-${idx}`}
                  className={kind === 'caution' ? 'ai-crew-chip-caution' : 'ai-crew-chip-plus'}
                >
                  {kind === 'caution' ? (
                    <CloseCircleFilled style={{ fontSize: 11, color: '#dc2626' }} />
                  ) : (
                    <CheckCircleFilled style={{ fontSize: 11, color: '#10b981' }} />
                  )}
                  {chip.text}
                </span>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}
